import axios from "axios";
import { store } from "@/employee/components/state/store.js";
import { handleLogout } from "@/employee/components/state/middleware/handleLogout.js";

// import ApiService from '@/pad/components/request/requestSeUsed'

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: { "Content-Type": "application/json;charset=utf-8" },
});

const encodeParams = (params = {}) => {
  if (!params || typeof params !== "object") return "";
  const query = new URLSearchParams(params).toString();
  return query ? `?${query}` : "";
};

// Allow localhost, block all other external URLs
const validateUrl = (url) => {
  if (url.includes("localhost:9001")) return;
  if (/^https?:\/\//i.test(url)) {
    throw new Error("External URLs are not allowed.");
  }
};

class ApiService {
  constructor() {
    this.setupInterceptors();
  }

  async get(url, params = {}, config = {}) {
    validateUrl(url);
    const query = encodeParams(params);
    const response = await api.get(url + query, config);
    return response.data;
  }

  async post(url, data = {}, config = {}) {
    validateUrl(url);
    const response = await api.post(url, data ? data : {}, config);
    return response.data;
  }

  async put(url, params = {}, data = {}, config = {}) {
    validateUrl(url);
    if (params) {
      if (typeof params === "string") {
        url = url + `${url?.endsWith("/") ? "" : "/"}` + params;
      } else {
        const query = typeof params === "object" ? encodeParams(params) : typeof params === "string";
        url = url + query
      }
    }
    const response = await api.put(url, data ? data : {}, config);
    return response.data;
  }

  async patch(url, params = {}, data = {}, config = {}) {
    validateUrl(url);
    if (params) {
      if (typeof params === "string") {
        url = url + `${url?.endsWith("/") ? "" : "/"}` + params;
      } else {
        const query = typeof params === "object" ? encodeParams(params) : typeof params === "string";
        url = url + query
      }
    }
    const response = await api.patch(url, data ? data : {}, config);
    return response.data;
  }

  async delete(url, id = null, data = null, config = {}) {
    validateUrl(url);
    const finalUrl = id ? `${url}${url.endsWith("/") ? "" : "/"}${id}` : url;
    const response = await api.delete(finalUrl, {
      ...config,
      ...(data && { data }),
    });
    return response.data;
  }

  async delete2(url, data = {}, config = {}) {
    validateUrl(url);
    const response = await api.delete(url, { ...config, data });
    return response.data;
  }

  setupInterceptors() {
    api.interceptors.request.use(
      (config) => {
        const state = store.getState();
        const token = state?.loginStateReducer?.isLogin;
        const user = state?.userInfStateReducer?.userInfo;

        config.headers.timeZone =
          config?.headers?.timezones ?? user?.siteIdCurrent?.timeZone ?? -new Date().getTimezoneOffset() / 60;

        if (token) config.headers.Authorization = token;
        if (user?.siteId || config?.headers?.siteIds) config.headers.siteId = config?.headers?.siteIds || user.siteId;

        return config;
      },
      (error) => Promise.reject(error)
    );

    api.interceptors.response.use(
      (response) => {
        if (response?.data?.status === 401) handleLogout();
        return response;
      },
      (error) => {
        if (error?.response?.status === 401) handleLogout();
        return Promise.reject(error);
      }
    );
  }
}

export default new ApiService();